import Reflux from "reflux";

import Chip from "@reactComponents/lds/chips/Chip";
import FacetSearchStore from "@javascript/stores/facetSearchStore";

import { timeFrameInWords } from "@javascript/helpers/dateTimeUtilities"

const FacetSearchCriteriaTimeFrame = createReactClass({
  mixins: [
    Reflux.connectFilter(FacetSearchStore, function (data) {
      return data.timeFrame;
    }),
  ],
  getInitialState: function () {
    return {
      ...(FacetSearchStore.data.timeFrame)
    };
  },
  shouldComponentUpdate: function (nextProps, nextState) {
    return true
  },
  resetTimeSelect: function() {
    reset_time_select();
  },
  render: function(){
    // The URL is our source of truth here, since that is the active search
    const { selected, earliest, latest } = FacetSearchStore.getActiveTimeFrame();

    let timeFrameDescription = timeFrameInWords({selected, earliest, latest, capitalize: true});

    if (timeFrameDescription === null) return null;

    let trailingIcon = "cancel";

    return (
      <Chip
        className="search_filter_applied_chip"
        label={timeFrameDescription}
        leadingIcon="calendar"
        size="small"
        trailingIcon={trailingIcon}
        trailingIconClassName="search_filter_applied_trailing_icon"
        trailingIconOnClick={this.resetTimeSelect}
        variant="secondary"
      />
    );
  }
});

window.FacetSearchCriteriaTimeFrame = FacetSearchCriteriaTimeFrame;
export default FacetSearchCriteriaTimeFrame;
